import { useEffect, useState } from 'react';
import {
  filterOptions,
  renderTemplateOptions,
} from '../sharedComponents/SearchBox/utils';
import { ISelectedOption } from '../../@types/searchBox';
import { useDebounce } from './useDebounce';
import { ITemplateSearch } from './../../@types/myAuditList';
import { getSearchedMyAuditTemplates } from './../../../requests/myAudit';

export function useSearchTemplate (initialState: ISelectedOption[] = []) {
  const [searchText, setSearchText] = useState<string>('');
  const debounceSearchText = useDebounce(searchText);
  const [searchBoxOptions, setSearchBoxOptions] =
    useState<ISelectedOption[]>(initialState);
  const [selectedOptions, setSelectedOptions] =
    useState<ISelectedOption[]>(initialState);

  useEffect(() => {
    if (searchText.length > 0) {
      getSearchedMyAuditTemplates({
        pageNumber: 1,
        searchTerm: debounceSearchText,
      }).then((response) => {
        const templateList: ITemplateSearch[] = response.data.results;
        setSearchBoxOptions(
          filterOptions(searchText, renderTemplateOptions(templateList))
        );
      });
    }
  }, [debounceSearchText]);

  return {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSearchBoxOptions,
    setSelectedOptions,
    setSearchText,
  };
}
